import React from 'react';
import { Box, CloseIcon, IconButton } from '@razorpay/blade/components';

type ModalCloseButtonProps = {
  onClick: () => void;
  /** The data-testid the end-to-end page objects look the control up by. */
  testId?: string;
};

/** The close control of the report download modals: Blade's icon button, top right. */
const ModalCloseButton: React.FC<ModalCloseButtonProps> = ({
  onClick,
  testId,
}) => (
  // The test id sits on the box, which wraps the button exactly, because IconButton has no
  // testID prop in this Blade version.
  <Box position="absolute" top="spacing.5" right="spacing.5" testID={testId}>
    <IconButton
      icon={CloseIcon}
      onClick={onClick}
      accessibilityLabel="Close"
      size="medium"
      emphasis="intense"
    />
  </Box>
);

export default ModalCloseButton;
